import {
    ModelDataChangeCompanyFilter, ModelDataChangeFilterRegistry, ModelDataChangeResponsibilityFilter
} from "@mcleod/components";
import { ModelDataChangeFilterInitializer } from "@mcleod/common";

export class LMEModelDataChangeFilterInitializer extends ModelDataChangeFilterInitializer {
    public initialize() {
        super.initialize();
        ModelDataChangeFilterRegistry.get().register(
            new ModelDataChangeCompanyFilter(),
            new ModelDataChangeResponsibilityFilter()
        );
    }
}
